import api from 'api';
import type { NotificationAndReminderSettings } from 'redux/modules/notificationSettings.types';
import type { Notification } from 'types/notification';

export const notificationsApi = {
  getNotifications(): Promise<Array<Notification>> {
    return api.get('notifications');
  },

  getNotificationById(id: number): Promise<Notification> {
    return api.get(`users/notifications/${id}`, { accountPrefix: false });
  },

  markNotificationIdAsRead(id: number | string): Promise<void> {
    return api.put(`notifications/read?notification_ids=${id}`);
  },

  markNotificationIdsAsSeen(ids: Array<number> = []): Promise<void> {
    return api.put(`notifications/seen?notification_ids=${ids.join(',')}`);
  },

  getNotificationSettings() {
    return api.get('notifications/settings', { accountPrefix: false });
  },

  saveNotificationSettings(settings: NotificationAndReminderSettings) {
    return api.put('notifications/settings', settings, { accountPrefix: false });
  },
};
